import { IconFont } from '@/components/IconFont'
import { getPreTasks, linkPreTasks, unlinkPreTasks } from '@/services/task/task'
import { useRequest } from 'ahooks'
import { Button, Row } from 'antd'
import { memo, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import TaskAssign from '../components/TaskField/TaskAssign'
import TaskTreeSelect from '../components/TaskTreeSelect'
import styles from './index.module.less'

const Predecessors = memo((props: any) => {
  const { task, members } = props
  const [preTasks, setPreTasks] = useState<any[]>([])
  const { refresh } = useRequest(() => getPreTasks(task.id), { onSuccess: (data) => setPreTasks(data) })

  const handleAddTask = () => {
    setPreTasks((origin) => [...origin, { id: -1, parentId: task.id }])
  }

  const handleAddCancel = () => {
    setPreTasks((origin) => origin.filter((item) => item.id !== -1))
  }

  const handleUpdateTask = (data) => {
    setPreTasks((origin) => origin.map((item) => (item.id === data.id ? data : item)))
  }

  return (
    <div>
      <Row justify={'space-between'}>
        <h5>Predecessors</h5>

        <Button type='text' size={'small'} onClick={handleAddTask}>
          <IconFont type='icon-add' />
        </Button>
      </Row>

      {!!preTasks.length && (
        <div className={styles.taskList}>
          {preTasks.map((preTask) => (
            <div key={preTask.id} className={styles.listItem}>
              <div className={styles.itemNum}>
                <span>#{preTask.num}</span>
              </div>
              <div className={styles.itemName}>
                {preTask.id === -1 ? (
                  <TaskTreeSelect
                    taskId={task.id}
                    onBlur={handleAddCancel}
                    onChange={async (value) => {
                      const taskIds = preTasks.filter((task) => task.id !== -1).map((task) => task.id) || []
                      const predecessorTasks = [...taskIds, value]
                      await linkPreTasks(task.id, predecessorTasks)
                      refresh()
                    }}
                  />
                ) : (
                  <Link to={`../${preTask.id}`} className={'link'}>
                    {preTask.name}
                  </Link>
                )}
              </div>
              <div className={styles.itemAssign}>
                {preTask.id !== -1 && <TaskAssign members={members} task={preTask} onSuccess={handleUpdateTask} />}
              </div>
              <div className={styles.itemAction}>
                {preTask.id !== -1 && (
                  <Button
                    type='text'
                    size={'small'}
                    onClick={async () => {
                      await unlinkPreTasks(task.id, [preTask.id])
                      refresh()
                    }}
                  >
                    <IconFont type='icon-delete' />
                  </Button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
})

export default Predecessors
